export {
  createPromotionIntake,
  updatePromotionIntake,
  deletePromotionIntake,
} from '../application/promotionIntake';
